<template>
  <div class="dataview-chart" :class="{'loading-graph': isLoading }">
    <div class="grid-50w filters">
      <treeselect v-if="filters"
                  v-for="filter in filters"
                  :key="filter.instanceId"
                  v-model="filterValues[filter.instanceId]"
                  :multiple="isMultiple(filter)"
                  :clearable="isMultiple(filter)"
                  :options="filter.values"
                  :placeholder="filter.name"
                  :instanceId="filter.instanceId"
                  @close="filterChanged"
                  @input="filterChanged"/>

    </div>

    <div ref="eventMapElement" class="mapview">


    </div>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect"

export default {
  components: {
    Treeselect
  },
  props: {
    chartName: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.getMap();
    this.isLoading = false;
  },
  data: function()
  {
    return {
      map: null,
      popup: null,
      layerStockOut: null,
      dataSourceStockOut: null,
      filters: null,
      filterValues: {},
      isLoading: true,
    }
  },
  beforeDestroy: function () {
    if (this.map)
      this.map.dispose();
  },
  methods: {
    getMap() {
      this.isLoading = true;
      const filterKeys = Object
          .keys(this.filterValues)
          .filter(key => key)
          .map(key => {
            return {key: key, value: this.filterValues[key]}
          })
          .filter(x => x.value && x.value.length > 0);

      let filters = null;
      if (filterKeys.length > 0) {
        const filterList = {};
        filterKeys.forEach(x => {
          // force filter into canonical form ie. an array of chosen filters
          if (Array.isArray(x.value))
            filterList[x.key] = x.value;
          else
              // this happens when multiple: false. We force the single value into an array
            filterList[x.key] = [x.value];
        })

        filters = filterList;//JSON.stringify(filterList);
      }


      this.$store.dispatch("getDataViewChart", {
        name: this.chartName,
        filters: filters
      }).then((data) => {
        this.filters = data.filters;
        this.getSiteDepotLocations(data)
      }).finally(() => {
        this.isLoading = false;
      });
    }
    ,
    filterChanged() {
      if (this.map)
        this.map.dispose();
      this.getMap();
    }
    ,
    isMultiple(filter) {

      return true;
    }
    ,
    getSiteDepotLocations(data) {

      let mapCenter = [0, 0];
      this.dataSourceStockOut = new atlas.source.DataSource();

      data.series[0].data.forEach((pin) => {
        mapCenter = [pin.location.lon, pin.location.lat];

        let point = new atlas.data.Feature(new atlas.data.Point([pin.location.lon, pin.location.lat]), {
          name: pin.location.name,
          data: pin
        });

        this.dataSourceStockOut.add(point);
      });

      this.map = new atlas.Map(this.$refs.eventMapElement, {
        center: mapCenter,
        zoom: 4,
        style: "grayscale_light",
        language: "en-US",
        authOptions: this.$store.state.dataView.azureMaps.authOptions
      });

      this.map.events.add("ready", () => {

        let iconPromises = [
          this.map.imageSprite.add("icon_generic", "/images/map.generic.png"),
        ];

        Promise.all(iconPromises).then(() => {
          this.map.sources.add(this.dataSourceStockOut);

          // Stock Out Layer
          this.layerStockOut = new atlas.layer.SymbolLayer(this.dataSourceStockOut, null, {
            iconOptions: {
              allowOverlap: true,
              image: "icon_generic",
              anchor: "top",
              size: 0.5
            },
            textOptions: {
              textField: ["get", "name"]
            }
          });

          this.map.layers.add(this.layerStockOut);

          this.popup = new atlas.Popup({
            position: [0, 0],
            pixelOffset: [0, -18]
          });

          this.map.events.add("mousemove", this.layerStockOut, this.symbolHovered);
          this.map.events.add("mouseout", this.layerStockOut, this.closePopup);
        });
      });
    }
    ,
    closePopup() {
      this.popup.close();
    }
    ,
    symbolHovered(e) {
      //Make sure the event occurred on a shape feature.
      if (!e.shapes || e.shapes.length == 0)
        return;

      //By default, show the popup where the mouse event occurred.
      let pos = e.position;
      let offset = [0, 0];
      let properties;
      if (e.shapes[0] instanceof atlas.Shape) {
        properties = e.shapes[0].getProperties();
        //If the shape is a point feature, show the popup at the points coordinate.
        if (e.shapes[0].getType() === "Point") {
          pos = e.shapes[0].getCoordinates();
          offset = [0, -18];
        }
      } else {
        properties = e.shapes[0].properties;
        //If the shape is a point feature, show the popup at the points coordinate.
        if (e.shapes[0].type === "Point") {
          pos = e.shapes[0].geometry.coordinates;
          offset = [0, -18];
        }
      }

      let content =
          "<p><b>Date:</b> " + this.$moment(properties.data.date).format("DD-MMM-YYYY") + "</p>" +
          "<p><b>Location:</b> " + properties.name + "</p>" +
          "<table><tr><td style='font-weight: bold;padding: 5px 15px 0 0'>DUN</td><td style='font-weight: bold;padding: 5px 5px 0 0'>Stock Out</td><td style='font-weight: bold;padding: 5px 0 0 0'>Expired</td></tr>";

      for (let dun of properties.data.dispensingUnits) {
        content += "<tr><td>" + dun.name + "</td>" +
            "<td style='text-align: right'> " + dun.stockOut + "</td>" +
            "<td style='text-align: right'> " + dun.expired + "</td></tr>";
      }

      content += "</table>";

      this.popup.setOptions({
        //Create a table from the properties in the feature.
        content: "<div style='padding:15px 10px;'>" + content + "</div>",
        position: pos,
        pixelOffset: offset
      });


      this.popup.open(this.map);
    }
  }
}
</script>
